import React from "react";

/**
 * STAX product multi-select as checkboxes, grouped by category.
 * `selected` and the values emitted are product NAMES (stored on the lead as interested_products).
 */
export default function ProductCheckboxes({ products = [], selected = [], onChange, testidPrefix = "stax" }) {
  const toggle = (name) => {
    const set = new Set(selected || []);
    if (set.has(name)) set.delete(name);
    else set.add(name);
    onChange?.(Array.from(set));
  };

  const groups = React.useMemo(() => {
    const g = {};
    (products || []).forEach((p) => {
      const cat = p.category || "Other";
      (g[cat] = g[cat] || []).push(p);
    });
    return g;
  }, [products]);

  if (!products || products.length === 0) {
    return <div className="text-xs text-slate-400">No STAX products configured.</div>;
  }

  return (
    <div className="space-y-3" data-testid={`${testidPrefix}-picker`}>
      {Object.entries(groups).map(([cat, list]) => (
        <div key={cat}>
          <div className="text-[10px] font-mono uppercase tracking-wider text-slate-400 mb-1.5">{cat}</div>
          <div className="grid grid-cols-2 gap-1.5">
            {list.map((p) => {
              const checked = (selected || []).includes(p.name);
              return (
                <label
                  key={p.id}
                  data-testid={`${testidPrefix}-option-${p.id}`}
                  className={`flex items-center gap-2 rounded-md border px-2.5 py-1.5 text-xs cursor-pointer transition-colors ${
                    checked ? "bg-blue-50 border-blue-300 text-blue-900" : "bg-white border-slate-200 hover:border-slate-300 text-slate-700"
                  }`}
                >
                  <input
                    type="checkbox"
                    className="h-3.5 w-3.5 accent-blue-600"
                    checked={checked}
                    onChange={() => toggle(p.name)}
                  />
                  <span className="truncate">{p.name}</span>
                </label>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
